import { useEffect, useState } from 'react';

import { useNavigate, useLocation, Routes, Route } from 'react-router-dom';
import {
  PluginDevxprotectApplicationView,
  PluginDevxprotectExperienceInfo,
} from '@devxprotect/plugin-devxprotect-experience';
import {
  EntityPluginDevxprotectWorkflowCard,
  PluginDevxprotectWorkflowInfo,
} from '@devxprotect/plugin-devxprotect-workflow';
import { PluginManager, PluginType } from '../plugin/PluginManager';

/**
 * Security Widgets Component
 * @param props - Flag to enable UWL
 */
export const SecurityWidgets = ({ uwlEnabled }: { uwlEnabled: boolean }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [navigateToWorkflow, setNavigateToWorkflow] = useState(false);
  const [navigateBackToSecurity, setNavigateBackToSecurity] = useState(false);

  useEffect(() => {
    if (navigateToWorkflow) {
      const currentPath = location.pathname;
      navigate(`${currentPath}/workflow?type=java`, { replace: true });
      setNavigateToWorkflow(false);
    }
  }, [navigateToWorkflow, location, navigate, setNavigateToWorkflow]);

  useEffect(() => {
    if (navigateBackToSecurity) {
      const currentPath = location.pathname;
      const newPath = currentPath.replace('/workflow', '');
      navigate(newPath, { replace: true });
      setNavigateBackToSecurity(false);
    }
  }, [navigateBackToSecurity, location, navigate, setNavigateBackToSecurity]);

  return (
    <Routes>
      <Route
        index
        element={
          <PluginManager
            type={PluginType.TAB}
            modalContent={PluginDevxprotectExperienceInfo}
          >
            <PluginDevxprotectApplicationView
              uwlEnabled={uwlEnabled}
              setNavigate={setNavigateToWorkflow}
            />
          </PluginManager>
        }
      />
      <Route
        path="workflow"
        element={
          <PluginManager
            type={PluginType.TAB}
            modalContent={PluginDevxprotectWorkflowInfo}
          >
            <EntityPluginDevxprotectWorkflowCard
              setNavigate={setNavigateBackToSecurity}
            />
          </PluginManager>
        }
      />
    </Routes>
  );
};
